module.exports = __webpack_public_path__ + "static/media/battery-bolt.7b3b9f0f.svg";